import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

export default function NewsRow({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 sm:flex-row md:p-4"
    >
      <div className="h-44 w-full shrink-0 overflow-hidden rounded-md sm:h-32 sm:w-56">
        <img
          src={item.cover}
          alt={`${item.title} - 91动漫`}
          title={`${item.title} - 91动漫`}
          className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex flex-wrap items-center gap-2">
          {item.tags.map((t) => (
            <span
              key={t}
              className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800"
            >
              {t}
            </span>
          ))}
        </div>
        <h3 className="mt-2 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{item.summary}</p>
        <div className="mt-auto flex flex-wrap items-center gap-x-4 gap-y-1 pt-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1.5">
            <i className="ri-calendar-line text-sm" />
            {item.date}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-user-3-line text-sm" />
            {item.source}
          </span>
        </div>
      </div>
    </Link>
  );
}